import { DragAndDropFileUploader, PageSection } from "@app/shared";
import { UploadTagsWizardStepProps } from "./types";
import { authenticatedDownload } from "../../shared/AuthenticatedDownload";
import { QESButton } from "../../shared/qes-standards";
import React from "react";

class UploadTagsWizardImportList extends React.Component<UploadTagsWizardStepProps> {
  private helpFileUri = `${window.apiEndpointV2_0}/resourcetagging/uploadtagssamplefile`;
  private uploadObjectKey = "tagsFile";

  private downloadSampleFile = () => {
    authenticatedDownload(this.helpFileUri, undefined);
  }

  // React Built-Ins
  constructor(props: UploadTagsWizardStepProps) {
    super(props);
  }

  public render() {
    return (
      <PageSection>
        <div className="container">
          <p className="mt-3">
            Select the file you want to upload. The data must be in a <code>.csv</code> file. Or upload a file with the&nbsp;
            <QESButton
              qesType="secondary"
              className="bg-transparent font-weight-normal p-0"
              qesTestId="upload-tags-wizard-import-list__sample-file"
              onClick={this.downloadSampleFile}
            >
            correct format
            </QESButton>.
          </p>
          <DragAndDropFileUploader
            apiKeyName={this.uploadObjectKey}
            onUpload={this.props.handleUpload}
            filetype=".csv"
            hasBeenSuccessful={this.props.wasSuccessful}
            testId="upload-tags-wizard-import-list__file-input"
          />
        </div>
      </PageSection>
    );
  }
}

export default UploadTagsWizardImportList;
